/** Linked Record default value that stands for the record a Button was clicked on. */
export const ORIGINATING_RECORD_MARKER = "originating";

const ORIGINATING_RECORD_QUERY_PARAM = "originating_record";
const ORIGINATING_APP_QUERY_PARAM = "originating_app";

export interface OriginatingRecord {
  recordId: string;
  applicationId: string;
}

/**
 * Reads the record a Button was clicked on, forwarded by the host app via the form URL.
 * Returns undefined when the form wasn't opened from a record.
 */
export const getOriginatingRecordParam = (): OriginatingRecord | undefined => {
  const query = new URLSearchParams(window.location.search);
  const recordId = query.get(ORIGINATING_RECORD_QUERY_PARAM);
  const applicationId = query.get(ORIGINATING_APP_QUERY_PARAM);
  return recordId && applicationId ? { recordId, applicationId } : undefined;
};

/**
 * Replaces the Originating Record marker in a Linked Record default with the originating record.
 * The marker is dropped when the field links to another table or there is no originating record.
 */
export const resolveOriginatingRecordMarker = (
  ids: string[],
  linkedApplication: string | undefined,
  originatingRecord: OriginatingRecord | undefined
): string[] => {
  if (!ids.includes(ORIGINATING_RECORD_MARKER)) {
    return ids;
  }
  const replacement =
    originatingRecord && originatingRecord.applicationId === linkedApplication
      ? [originatingRecord.recordId]
      : [];
  return Array.from(
    new Set(ids.flatMap((id) => (id === ORIGINATING_RECORD_MARKER ? replacement : [id])))
  );
};
